// extracted by mini-css-extract-plugin
export default {"parent-mode":"tabs_parent-mode__ET6Gm","tabs":"tabs_tabs__ZVYrr","tab":"tabs_tab__buanL","active":"tabs_active__psD02"};